import TargetDashboard from './TargetDashboard'

export default TargetDashboard